import './message_banner.scss';

import React from 'react';
import { withRouter } from 'react-router-dom';

const MAIN_CLASS = 'banner-message-info-large';

/**
 * Gets the height of shipping update element.
 *
 * @returns {Number} The height of the child paragraph element within the main element.
 */
export const getShippingUpdateElementHeight = () => {
  let result = 0;
  const shippingUpdateElement = document.querySelector(`.${MAIN_CLASS}`);
  const shippingUpdateChildElement = shippingUpdateElement?.querySelector('div');

  // Get the height of the child element if it exists
  result = shippingUpdateChildElement?.clientHeight || 0;

  return result;
};

/**
 * Renders a shipping update message with the given information.
 * @returns {JSX.Element|null} The shipping update component.
 */
const ShippingUpdate = () => {
  return (
    <div className={MAIN_CLASS}>
      <div>
        <div className="banner-message-header">Shipping Update</div>
        <p className={`${MAIN_CLASS}__text`}>
          New cases and DEs will be shipped within <strong>15 business days</strong> from the date of approval. Item Requests will be shipped within{' '}
          <strong>5 business days</strong> from the date of approval.
          <br /> Thank you for being a valued customer of InSmile Braces.
        </p>
      </div>
    </div>
  );
};

export default withRouter(ShippingUpdate);
